import axios from "axios";
import { APP_ACCOUNT_API_ENDPOINT } from "constants/api_urls";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateAccountList, updateAccountsStatus } from "store/slices/account/accountSlice";
import { getUserToken } from "utils/functions/userToken";

const useGetAccountList = () => {
  const token = getUserToken();
  const { accounts = [] } = useSelector((state) => state?.account || {});
  const [accountList, setAccountList] = useState([]);
  const [hotelsList, setHotelsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  // Guards against a second, redundant `/accounts/list/v2` call: once the
  // first request succeeds, dispatching the account list re-runs this effect,
  // and if the API returned an empty hotel_list the old guard
  // (`!hotelsList.length`) would fire the request again. The ref ensures the
  // fetch happens once, while still allowing a retry if the request failed.
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    const fetchData = () => {
      if (hasFetchedRef.current) return;
      if (!accounts.length || !hotelsList.length) {
        hasFetchedRef.current = true;
        setLoading(true);
        dispatch(updateAccountsStatus("loading"));
        axios
          .get(`${APP_ACCOUNT_API_ENDPOINT}/api/accounts/list/v2`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            dispatch(updateAccountList(res?.data?.account_list || []))
            setAccountList(res?.data?.account_list || []);
            setHotelsList(res?.data?.hotel_list || []);
            setLoading(false);
            dispatch(updateAccountsStatus("succeeded"));
          })
          .catch((err) => {
            hasFetchedRef.current = false;
            console.error(err);
            setLoading(false);
            dispatch(updateAccountsStatus("failed"));
          });
      }
    };

    fetchData();
  }, [JSON.stringify(accounts), token, JSON.stringify(hotelsList), dispatch]);

  return {
    accountList,
    hotelsList,
    loading,
  };
};

export default useGetAccountList;
